import React from 'react'
import OverviewReqComponent from '../../components/marketingGuidelines/marketingComponents/OverviewRequirements/OverviewReqComponent'
import { Col } from 'react-bootstrap';

import './overviewReqLayout.scss'

class OverviewReqLayout extends React.Component {
    render() {
        return <div className="overview-layout">
            <div className="warning-section">
                <Col xs={1} align="center">
                    <span className='icon-warning-grey' />
                </Col>
                <p>Use of the Life Fitness logo requires the expressed written consent from Life Fitness. Contact <a href="mailto:developers@lifefitness.com">developers@lifefitness.com</a> for information.</p>
            </div>
            <br />
            <h2>Overview and Requirements</h2>
            <OverviewReqComponent />
        </div>
    }
}

export default OverviewReqLayout



// WEBPACK FOOTER //
// ./src/layouts/OverviewReq/OverviewReqLayout.js